var $189e23eec1d6aa3a$exports = {};
$189e23eec1d6aa3a$exports = {
  "ascending": "n\xF6vekv\u0151",
  "ascendingSort": function ascendingSort(args) {
    return "rendezve a(z) ".concat(args.columnName, " oszlop szerint, n\xF6vekv\u0151 sorrendben");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " k\xE9ppont");
  },
  "descending": "cs\xF6kken\u0151",
  "descendingSort": function descendingSort(args) {
    return "rendezve a(z) ".concat(args.columnName, " oszlop szerint, cs\xF6kken\u0151 sorrendben");
  },
  "resizerDescription": "Nyomja le az Enter billenty\u0171t az \xE1tm\xE9retez\xE9s megkezd\xE9s\xE9hez",
  "select": "Kijel\xF6l\xE9s",
  "selectAll": "\xD6sszes kijel\xF6l\xE9se",
  "sortable": "rendezend\u0151 oszlop"
};
export { $189e23eec1d6aa3a$exports as default };